<div class="w-100">
  <div class="placeholder placeholder-wave placeholder-slider w-100">
    <div class="container">
      <div class="row py-5">
        <div class="col-12 mb-3 ps-4">
          <div class="placeholder placeholder__line placeholder-slider__macro"></div>
        </div>
        <div class="col-2">
          <div class="placeholder placeholder-slider__price w-100 rounded-1"></div>
        </div>
        <div class="col-8 d-flex flex-column">
          <div class="placeholder placeholder__line placeholder-slider__macro mb-3 mt-1"></div>
          <div class="placeholder placeholder__line placeholder-slider__macro" style="height: 20px;"></div>
        </div>
        <div class="col-2">
          <div class="placeholder placeholder-slider__price w-100 rounded-1"></div>
        </div>
      </div>
    </div>
  </div>
</div>
